import addressProviderDefinition from './api.js';
import addressesCacheAtomDefinition from './atoms.js';
import mockableAddressProviderModuleDefinition from './mock.js';
import addressProviderModuleDefinition from './module.js';
import addressProviderPluginDefinition from './plugin.js';
const addressProvider = ({ mockable = false } = {}) => {
    return {
        id: 'addressProvider',
        definitions: [
            {
                definition: mockable
                    ? {
                        ...mockableAddressProviderModuleDefinition,
                        id: addressProviderModuleDefinition.id,
                    }
                    : addressProviderModuleDefinition,
            },
            { definition: addressProviderDefinition },
            { definition: addressProviderPluginDefinition },
            {
                definition: addressesCacheAtomDefinition,
                storage: { namespace: 'addressProvider' },
            },
        ],
    };
};
export default addressProvider;
